import { Card, CardContent, Stack } from '@mui/material';
import ConsultantLoginForm from './components/ConsultantLoginForm/ConsultantLoginForm';
import ConsultantLoginFormProvider from './components/ConsultantLoginFormProvider';
import UserLoginForm from './components/UserLoginForm';
import UserLoginFormProvider from './components/UserLoginFormProvider';
import { useShowNotAuthorizedMessage } from './hooks/useShowNotAuthorizedMessage';

type Props = {
    closeDialog?: () => void;
    openForgotPassword: () => void;
};

export default function Login({ openForgotPassword }: Props) {
    useShowNotAuthorizedMessage();

    return (
        <Stack gap={2} sx={{ maxWidth: 400, margin: '24px auto' }}>
            <Card elevation={2} data-testid="customer-login-form">
                <CardContent sx={{ '&:last-child': { paddingBottom: 0 } }}>
                    <UserLoginFormProvider>
                        <UserLoginForm openForgotPassword={openForgotPassword} />
                    </UserLoginFormProvider>
                </CardContent>
            </Card>
            <Card elevation={2} data-testid="consultant-login-form">
                <CardContent sx={{ '&:last-child': { paddingBottom: 0 } }}>
                    <ConsultantLoginFormProvider>
                        <ConsultantLoginForm />
                    </ConsultantLoginFormProvider>
                </CardContent>
            </Card>
        </Stack>
    );
}
